module.exports = __webpack_public_path__ + "static/media/newsletter-may-2021-readings.0d9bbb4f.jpg";